export default [
	{
		path: "configureView",
		name: "CONFIGURE_VIEW",
		meta: {
			title: "样式配置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/configureView.vue"),
	},
	{
		path: "appraisalClass",
		name: "APPRAISAL_CLASS",
		meta: {
			title: "测评分类",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/appraisalClass.vue"),
	},
	// configureView
	{
		path: "shareSet",
		name: "SHARE_SET",
		meta: {
			title: "分享设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/shareSet/shareSet.vue"),
	},
	{
		path: "topicList",
		name: "TOPIC_LIST",
		meta: {
			title: "题库列表",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList.vue"),
	},
	//塔罗
	{
		path: "tarotTypeList",
		name: "Tarot_Type_List",
		meta: {
			title: "类型设置",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/topic/TarotList/typeList.vue"),
	},
	{
		path: "TarotTestList",
		name: "Tarot_Test_List",
		meta: {
			title: "分类列表",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/topic/TarotList/TarotTestList.vue"),
	},
	{
		path: "CardFaceList",
		name: "Card_Face_List",
		meta: {
			title: "塔牌设置",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/topic/TarotList/CardFaceList.vue"),
	},

	{
		path: "topicMain",
		name: "TOPIC_MAIN",
		meta: {
			title: "测评题主页",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicStyle/topicMain.vue"),
	},

	{
		path: "topicResult",
		name: "TOPIC_RESULT",
		meta: {
			title: "测评题结果页",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicStyle/topicResult.vue"),
	},
	{
		path: "topicAnswer",
		name: "TOPIC_ANSWER",
		meta: {
			title: "测评答题页",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicStyle/topicAnswer.vue"),
	},

	/**
	 * 题目列表
	 */
	{
		path: "jzList",
		name: "JZ_LIST",
		meta: {
			title: "基准题目列表",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/jzList.vue"),
	},
	{
		path: "qysList",
		name: "QYS_LIST",
		meta: {
			title: "潜意识题目列表",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/qysList.vue"),
	},
	// 大五人格设置
	{
		path: "DWList",
		name: "DW_List",
		meta: {
			title: "基准题目列表",
			icon: "",
			isNav: true,
		},
		component: () =>
			import("@/views/topic/BigFivePersonality/BasicConfiguration.vue"),
	},
	{
		path: "wdList",
		name: "WD_LIST",
		meta: {
			title: "维度题目列表",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/wdList.vue"),
	},
	{
		path: "jzqxList",
		name: "JZQX_LIST",
		meta: {
			title: "基准倾向题目列表",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/jzqxList.vue"),
	},{
		path: "niqList",
		name: "NIQ_LIST",
		meta: {
			title: "新智商题目列表",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/niqList.vue"),
	},

	/**
	 * 结果设置
	 */
	{
		path: "jzSet",
		name: "JZ_SET",
		meta: {
			title: "基准结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/jzSet.vue"),
	},
	{
		path: "wdSet",
		name: "WD_SET",
		meta: {
			title: "维度结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/wdSet.vue"),
	},
	{
		path: "qysSet",
		name: "QYS_SET",
		meta: {
			title: "潜意识结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/qysSet.vue"),
	},
	{
		path: "jzqxSet",
		name: "JZQX_SET",
		meta: {
			title: "基准倾向结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/jzqxSet.vue"),
	},
	{
		path: "rgtphxSet",
		name: "RGTPHX_SET",
		meta: {
			title: "测评画像结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/rgtphxSet.vue"),
	},
	{
		path: "rgtpSet",
		name: "RGTP_SET",
		meta: {
			title: "测评基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/rgtpSet.vue"),
	},
	{
		path: "rgtpList",
		name: "RGTP_List",
		meta: {
			title: "测评题目",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/rgtpList.vue"),
	},
	{
		path: "wdpjList",
		name: "WDPJ_LIST",
		meta: {
			title: "测评题目",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/wdpjList.vue"),
	},
	{
		path: "wdpjSet",
		name: "WDPJ_SET",
		meta: {
			title: "结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/wdpjSet.vue"),
	},
	{
		path: "wdscList",
		name: "WDSC_LIST",
		meta: {
			title: "测评题目",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/wdscList.vue"),
	},
	{
		path: "wdscSet",
		name: "WDSC_SET",
		meta: {
			title: "结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/wdscSet.vue"),
	},

	{
		path: "ejwdList",
		name: "EJWD_LIST",
		meta: {
			title: "测评题目",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/ejwdList.vue"),
	},
	{
		path: "ejwdSet",
		name: "EJWD_SET",
		meta: {
			title: "结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/ejwdSet.vue"),
	},

	{
		path: "ahrgList",
		name: "AHRG_LIST",
		meta: {
			title: "测评题目",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/ahrgList.vue"),
	},
	{
		path: "anrgSet",
		name: "ANRG_SET",
		meta: {
			title: "基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/anrgSet.vue"),
	},
	{
		path: "ahrgzsSet",
		name: "AHRGZS_SET",
		meta: {
			title: "指数及人格结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/ahrgzsSet.vue"),
	},

	{
		path: "tcrgList",
		name: "TCRG_LIST",
		meta: {
			title: "基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/tcrgList.vue"),
	},
	{
		path: "tcrgSet",
		name: "TCRG_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/tcrgSet.vue"),
	},

	{
		path: "mbtiList",
		name: "MBTI_LIST",
		meta: {
			title: "基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/mbtiList.vue"),
	},
	{
		path: "mbtiSet",
		name: "MBTI_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/mbtiSet.vue"),
	},

	{
		path: "wdzhList",
		name: "WDZH_LIST",
		meta: {
			title: "基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/wdzhList.vue"),
	},
	{
		path: "wdzhSet",
		name: "WDZH_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/wdzhSet.vue"),
	},

	{
		path: "rgmlList",
		name: "RGML_LIST",
		meta: {
			title: "基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/rgmlList.vue"),
	},
	{
		path: "rgmlSet",
		name: "RGML_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/rgmlSet.vue"),
	},

	{
		path: "aqsyList",
		name: "AQSY_LIST",
		meta: {
			title: "基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/aqsyList.vue"),
	},
	{
		path: "aqsySet",
		name: "AQSY_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/aqsySet.vue"),
	},
	{
		path: "mjywlList",
		name: "MJYWL_LIST",
		meta: {
			title: "基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/mjywlList.vue"),
	},
	{
		path: "mjywlSet",
		name: "MJYWL_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/mjywlSet.vue"),
	},
	{
		path: "mjywlRgSet",
		name: "MJYWL_RG_SET",
		meta: {
			title: "人格类型结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/mjywlRgSet.vue"),
	},
	{
		path: "mjywlRgCtSet",
		name: "MJYWL_RG_CT_SET",
		meta: {
			title: "人格类型结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/mjywlRgCtSet.vue"),
	},
	{
		path: "tzfgList",
		name: "TZFG_LIST",
		meta: {
			title: "基础结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/tzfgList.vue"),
	},
	{
		path: "xltpList",
		name: "XLTP_LIST",
		meta: {
			title: "心理图谱题目",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/xltpList.vue"),
	},
	{
		path: "xltpSet",
		name: "XLTP_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/xltpSet.vue"),
	},
	{
		path: "xltpRelationSet",
		name: "XLTP_RELATION_SET",
		meta: {
			title: "关联设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/relationSet/xltpRelationSet.vue"),
	},
	{
		path: "stfsyList",
		name: "STFSY_LIST",
		meta: {
			title: "斯坦福实验题目",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/stfsyList.vue"),
	},
	{
		path: "stfsySet",
		name: "STFSY_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/stfsySet.vue"),
	},
	{
		path: "xlsyList",
		name: "XLSY_LIST",
		meta: {
			title: "心理实验题目",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/xlsyList.vue"),
	},
	{
		path: "xlxySet",
		name: "XLSY_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/xlsySet.vue"),
	},
	{
		path: "zyList",
		name: "zy_LIST",
		meta: {
			title: "资源设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/topicList/zyList.vue"),
	},
	{
		path: "tzfglSet",
		name: "TZFG_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/tzfgSet.vue"),
	},
	{
		path: "tzfgRgSet",
		name: "TZFG_RG_SET",
		meta: {
			title: "脸谱详情设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/tzfgRgSet.vue"),
	},
	{
		path: "niqSet",
		name: "NIQ_SET",
		meta: {
			title: "题目结果设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/topic/resultSet/niqSet.vue"),
	},
];
